import { Helmet } from 'react-helmet';
import RefreshButton from 'components/Button/RefreshButton';
import { translate } from 'utils';
import { getIsProdEnv } from 'utils/getEnv';
import HelpInfoDefault from 'components/HelpInfo/HelpInfoDefault';
import Button from 'components/Button/Button';
import { Card, Typography } from 'components';
import classes from 'classnames';
import { useTranslation } from 'react-i18next';
import useWelcomeBackOverallStatus from './useWelcomeBackOverallStatus';
import s from './WelcomeBackIdentificationStatus.module.scss';
import IdentificationStatus from './IdentificationStatus';
import useWelcomeBackIdentificationStatus from './useWelcomeBackIdentificationStatus';

export default function WelcomeBackIdentificationStatus() {
  const { t } = useTranslation(['welcome_back', 'common', 'bank_id_error']);

  const {
    identityStatusProps,
    bankAccountStatusProps,
    bothStatusesAreApproved,
    handleBothApprovedClick,
    isLoading,
    fetchStatus,
    isForbiddenIdentificationStatus,
  } = useWelcomeBackIdentificationStatus();
  const { overallStatusText } = useWelcomeBackOverallStatus();

  return (
    <>
      <Helmet>
        <title>{translate('welcome_back.html_title')}</title>
      </Helmet>

      {isForbiddenIdentificationStatus ? (
        <>
          <Typography
            kind="h1"
            size="xl"
            color="primary"
            className={s.textCenter}
          >
            {t('bank_id_error:foreigner.title')}
          </Typography>
          <Typography size="s" className={classes(s.description, s.textCenter)}>
            {t('bank_id_error:foreigner.description')}
          </Typography>
          <div className={s.helpInfo}>
            <HelpInfoDefault />
          </div>
        </>
      ) : (
        <>
          <Typography className={s['card-title']} size="l" fontWeight={600}>
            {translate('welcome_back.title')}
          </Typography>

          <Card className={s.card}>
            <IdentificationStatus
              isLoaded={Boolean(identityStatusProps) && !isLoading}
              title={identityStatusProps?.title}
              type={identityStatusProps?.type || 'waiting'}
              description={identityStatusProps?.description}
              navigateTo={identityStatusProps?.navigateTo}
              statusType={identityStatusProps?.statusType}
            />

            <div className={s.divider} />

            <IdentificationStatus
              isLoaded={Boolean(bankAccountStatusProps) && !isLoading}
              title={bankAccountStatusProps?.title}
              type={bankAccountStatusProps?.type || 'waiting'}
              description={bankAccountStatusProps?.description}
              navigateTo={bankAccountStatusProps?.navigateTo}
              statusType={bankAccountStatusProps?.statusType}
            />

            <div className={s.divider} />

            {overallStatusText && (
              <>
                <div className="flex items-center">
                  <span className="text-sm">{overallStatusText}</span>
                </div>

                <div className="flex justify-center my-4">
                  <RefreshButton
                    // 5 minutes for production, 10 seconds for other environments
                    delaySeconds={getIsProdEnv() ? 300 : 10}
                    onRefresh={fetchStatus}
                    dataTest="welcome_back.refresh.button"
                    text={translate('welcome_back.refresh_button_text')}
                  />
                </div>
              </>
            )}

            {bothStatusesAreApproved && (
              <Button
                onClick={handleBothApprovedClick}
                className={s.button}
                dataTest="welcome_back.both_approved.button"
                disabled={isLoading}
              >
                {translate('common.continue')}
              </Button>
            )}
            <div className="mt-10">
              <HelpInfoDefault />
            </div>
          </Card>
        </>
      )}
    </>
  );
}
